import {useAppContext} from "../react/hooks/useAppContext";

export function useMobileView() {
    const {isMobile} = useAppContext();

    return isMobile;
}
